module.exports = __webpack_public_path__ + "static/media/casi_lo_logras_2.5495c938.png";